import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import {
  checkForAppUpdate,
  isChunkLoadError,
  markAppUpdateAvailable,
} from "@/util/app-version"
// import Home from "../views/SystemSetting/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/system/info",
  },
  {
    path: "/system",
    name: "systemInfoDefault",
    component: () => import("../views/system-settimg/index.vue"),
    children: [
      {
        path: "info",
        name: "systemInfo",
        component: () => import("../views/system-settimg/systemInfo/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "shippingRule",
        name: "systemShippingRule",
        component: () =>
          import("../views/system-settimg/shipping-rule/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "closeDate",
        name: "closeDate",
        component: () => import("../views/system-settimg/close-date/index.vue"),
        meta: {
          keepAlive: true,
        },
      },
    ],
  },

  {
    path: "/community",
    name: "community",
    component: () => import("../views/community-manage/index.vue"),
    meta: {
      keepAlive: true,
    },
  },

  {
    path: "/goodsCategory",
    name: "goodsCategory",
    component: () => import("../views/goods-manage/goods-category/index.vue"),
    meta: {
      keepAlive: true,
    },
  },

  {
    path: "/goodsFuturePrice",
    name: "goodsFuturePrice",
    component: () =>
      import("../views/goods-manage/goods-future-price/index.vue"),
    meta: {
      keepAlive: true,
    },
  },

  {
    path: "/goodsTodayLimit",
    name: "goodsTodayLimit",
    component: () =>
      import("../views/goods-manage/goods-today-limit/index.vue"),
    meta: {
      keepAlive: true,
    },
  },

  {
    path: "/goodsSummary",
    name: "goodsSummary",
    component: () => import("../views/goods-manage/goods-summary/index.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/discount",
    name: "discount",
    component: () => import("../views/discount-manage/index.vue"),
    meta: {
      keepAlive: true,
    },
  },

  {
    path: "/goodsList",
    name: "goodsList",
    component: () => import("../views/goods-manage/goods-list/index.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/goodsDetail/:id",
    name: "goodsDetail",
    component: () => import("../views/goods-manage/goods/index.vue"),
  },
  {
    path: "/addGoods",
    name: "addGoods",
    component: () => import("../views/goods-manage/goods/index.vue"),
  },
  {
    path: "/order/:id",
    name: "order",
    component: () => import("../views/order-manage/order/index.vue"),
  },
  {
    path: "/orderList",
    name: "orderList",
    component: () => import("../views/order-manage/order-list/index.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/orderGoodsList",
    name: "orderGoodsList",
    component: () => import("../views/order-goods-manage/index.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/deliveryList",
    name: "deliveryList",
    component: () => import("../views/delivery-manage/index.vue"),
  },
  {
    path: "/deliveryList-new",
    name: "deliveryListNew",
    component: () => import("../views/delivery-manage-new/index.vue"),
  },
  {
    path: "/addressManage",
    name: "addressManage",
    component: () => import("../views/address-manage/index.vue"),
  },
  {
    path: "/userList",
    name: "userList",
    component: () => import("../views/user-manage/index.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/print",
    name: "print",
    component: () => import("../views/print-manage/index.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/restock",
    name: "restock",
    component: () => import("../views/restock-manage/index.vue"),
    meta: {
      keepAlive: true,
    },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach(() => {
  void checkForAppUpdate()
})

router.onError((error) => {
  if (isChunkLoadError(error)) {
    markAppUpdateAvailable()
    void checkForAppUpdate()
  }
})

export default router
